import { z } from "zod";

const BrowseAuditsSchema = z.object({
  page: z.number().min(1, { message: "Page is out of bounds" }),
  query: z.any(),
  search: z.string(),
  sort: z.array(z.object({ property: z.string(), asc: z.boolean() })).nullish(),
});

export default BrowseAuditsSchema;
